
import { ScrollArea } from "@/components/ui/scroll-area";
import PublicHeader from "@/components/layout/PublicHeader";

const Terms = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Fixed Header */}
      <PublicHeader 
        title="Termini di Servizio" 
        subtitle="Ultimo aggiornamento: Gennaio 2024"
      />

      {/* Content with top padding for fixed header */}
      <div className="pt-20">
        <ScrollArea className="h-[calc(100vh-80px)]">
          <main className="container mx-auto px-4 py-6 max-w-4xl">
            <div className="prose prose-lg max-w-none">
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-[#030A14] mb-4">1. Introduzione</h2>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  Benvenuto su Place2Be, la piattaforma che connette travel designer esperti con viaggiatori 
                  in cerca di esperienze uniche e personalizzate. Utilizzando i nostri servizi, accetti di 
                  essere vincolato dai presenti Termini di Servizio.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-[#030A14] mb-4">2. Definizioni</h2>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li><strong>Piattaforma:</strong> Il sito web e l'applicazione Place2Be</li>
                  <li><strong>Travel Designer:</strong> Professionisti specializzati nella creazione di itinerari di viaggio</li>
                  <li><strong>Viaggiatore:</strong> Utenti che richiedono servizi di progettazione di viaggi</li>
                  <li><strong>Servizi:</strong> Tutti i servizi offerti attraverso la nostra piattaforma</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-[#030A14] mb-4">3. Registrazione e Account</h2>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  Per utilizzare Place2Be è necessario creare un account fornendo informazioni accurate e complete. 
                  Sei responsabile di mantenere la riservatezza delle credenziali del tuo account.
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>Devi avere almeno 18 anni per registrarti</li>
                  <li>Le informazioni fornite devono essere veritiere e aggiornate</li>
                  <li>È vietato condividere le credenziali di accesso</li>
                  <li>Notifica immediatamente qualsiasi uso non autorizzato del tuo account</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-[#030A14] mb-4">4. Servizi per Travel Designer</h2>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  I travel designer possono utilizzare la nostra piattaforma per:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>Creare e pubblicare itinerari di viaggio personalizzati</li>
                  <li>Gestire prenotazioni e pagamenti attraverso il sistema integrato</li>
                  <li>Comunicare con i viaggiatori attraverso gli strumenti della piattaforma</li>
                  <li>Accedere a strumenti professionali per la gestione del business</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-[#030A14] mb-4">5. Servizi per Viaggiatori</h2>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  I viaggiatori possono utilizzare Place2Be per:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>Richiedere itinerari di viaggio personalizzati</li>
                  <li>Consultare e confrontare proposte di diversi travel designer</li>
                  <li>Effettuare pagamenti sicuri attraverso Stripe</li>
                  <li>Ricevere supporto durante l'intero processo di pianificazione</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-[#030A14] mb-4">6. Pagamenti e Commissioni</h2>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  Place2Be utilizza Stripe per elaborare i pagamenti in modo sicuro. Le commissioni vengono 
                  applicate secondo la struttura tariffaria pubblicata sul sito.
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>I pagamenti sono elaborati in modo sicuro tramite Stripe</li>
                  <li>Le commissioni sono trattenute automaticamente sui pagamenti ricevuti</li>
                  <li>I rimborsi sono soggetti alle politiche specifiche di ciascun travel designer</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-[#030A14] mb-4">7. Responsabilità</h2>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  Place2Be agisce come intermediario tra travel designer e viaggiatori. Non siamo responsabili 
                  per la qualità dei servizi forniti dai travel designer o per eventuali problemi durante i viaggi.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-[#030A14] mb-4">8. Proprietà Intellettuale</h2>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  Tutti i contenuti della piattaforma Place2Be sono protetti da diritti d'autore. 
                  Gli utenti mantengono i diritti sui contenuti che caricano, ma concedono a Place2Be 
                  una licenza per utilizzarli nell'ambito dei servizi offerti.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-[#030A14] mb-4">9. Modifiche ai Termini</h2>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  Place2Be si riserva il diritto di modificare questi termini in qualsiasi momento. 
                  Le modifiche saranno notificate agli utenti e diventeranno effettive dopo 30 giorni 
                  dalla pubblicazione.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-[#030A14] mb-4">10. Contatti</h2>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  Per domande sui presenti Termini di Servizio, contattaci a:
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Email: legal@place2be.com<br />
                  Telefono: +39 012 345 6789<br />
                  Indirizzo: Via Milano 123, 20100 Milano, Italia
                </p>
              </section>
            </div>
          </main>
        </ScrollArea>
      </div>
    </div>
  );
};

export default Terms;
